/*! fromentries. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

//This mimics the behavior of Object.fromEntries, but since that isn't supported in IE, we are using this.
export default function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}
